<template>
  <div>
    <TextInput
      label="First Name"
      placeholder="Elon"
      :model-value="modelValue.firstName"
      @update:model-value="update('firstName', $event)"
    />
    <TextInput
      class="mt-4"
      label="Last Name"
      placeholder="Husk"
      :model-value="modelValue.lastName"
      @update:model-value="update('lastName', $event)"
    />
    <PhoneInput
      class="mt-4"
      label="Phone Number"
      placeholder="+1 (281) 330 8004"
      :model-value="modelValue.phone"
      @update:model-value="update('phone', $event)"
    />
    <TextInput
      class="mt-4"
      label="Email"
      placeholder="you@example.com"
      :model-value="modelValue.email"
      @update:model-value="update('email', $event)"
    />
    <SelectDropdown
      class="mt-4"
      label="License Status"
      :initial-value="modelValue.licenseStatus ? modelValue.licenseStatus : undefined"
      :options="['Licensed', 'License In Progress', 'Unlicensed', 'Unknown']"
      @selected-option="update('licenseStatus', $event)"
    />
    <TextInput
      class="mt-4"
      label="RE License Number"
      placeholder="123456"
      :optional="true"
      :model-value="modelValue.reLicenseNumber"
      @update:model-value="update('reLicenseNumber', $event)"
    />
  </div>
</template>

<script>
import SelectDropdown from '../shared/SelectDropdown.vue';
export default {
  components: {
    SelectDropdown,
  },
  props: ['modelValue'],
  data() {
    return {
      showValidation: false,
    };
  },
  methods: {
    update(key, value) {
      this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
    },
  },
};
</script>
